import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import VisitorRegistration from '@/pages/VisitorRegistration';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Departments from '@/pages/admin/Departments';
import Employees from '@/pages/admin/Employees';
import Guards from '@/pages/admin/Guards';
import PendingApprovals from '@/pages/PendingApprovals';
import History from '@/pages/History';
// FASE 1: Academy & Projects
import AdminProjects from '@/pages/admin/AdminProjects';
import AdminPersonal from '@/pages/admin/AdminPersonal';
import AdminCourses from '@/pages/admin/AdminCourses';
import CourseEditor from '@/pages/admin/CourseEditor';
import DiplomaEditor from '@/pages/admin/DiplomaEditor';
import CourseAttempts from '@/pages/admin/CourseAttempts';
import AdminSystem from '@/pages/admin/AdminSystem';
import TrainingReports from '@/pages/admin/TrainingReports';
import AdminIntranet from '@/pages/admin/AdminIntranet';
import Academy from '@/pages/academy/Academy';
import CourseViewer from '@/pages/academy/CourseViewer';
import Evaluation from '@/pages/academy/Evaluation';
import Certificate from '@/pages/academy/Certificate';
import MyDiplomas from '@/pages/academy/MyDiplomas';
import Intranet from '@/pages/intranet/Intranet';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VisitorRegistration />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin/departments" element={<Departments />} />
          <Route path="/admin/employees" element={<Employees />} />
          <Route path="/admin/guards" element={<Guards />} />
          <Route path="/guard/pending" element={<PendingApprovals />} />
          <Route path="/history" element={<History />} />

          {/* FASE 1: Admin academy & projects */}
          <Route path="/admin/projects" element={<AdminProjects />} />
          <Route path="/admin/personal" element={<AdminPersonal />} />
          <Route path="/admin/courses" element={<AdminCourses />} />
          <Route path="/admin/courses/new" element={<CourseEditor />} />
          <Route path="/admin/courses/:courseId" element={<CourseEditor />} />
          <Route path="/admin/courses/:courseId/diploma" element={<DiplomaEditor />} />
          <Route path="/admin/courses/:courseId/intentos" element={<CourseAttempts />} />
          <Route path="/admin/sistema" element={<AdminSystem />} />
          <Route path="/admin/training-reports" element={<TrainingReports />} />
          <Route path="/admin/intranet" element={<AdminIntranet />} />

          {/* FASE 1: Personal academy */}
          <Route path="/intranet" element={<Intranet />} />
          <Route path="/academia" element={<Academy />} />
          <Route path="/academia/curso/:courseId" element={<CourseViewer />} />
          <Route path="/academia/evaluacion/:courseId" element={<Evaluation />} />
          <Route path="/academia/certificado/:courseId" element={<Certificate />} />
          <Route path="/mis-diplomas" element={<MyDiplomas />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
